export var CUSTOM_STATE_CHANGE_TYPES = {
  BACKSPACE_REMOVE: '__custom_backspace_remove__',
  DELETE_REMOVE: '__custom_delete_remove__',
  BLUR_RESET: '__custom_blur_reset__',
  ADD_FREEFORM_VALUE: '__custom_add_freeform_value__',
  CLEAR_SELECTION_AT_INDEX: '__custom_clear_selection_at_index__'
};
export var MENU_STATES = {
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  HELPER: 'HELPER',
  HAS_ITEMS: 'HAS_ITEMS',
  NO_RESULTS_FOUND: 'NO_RESULTS_FOUND'
}; // Actions

export var SET_ITEMS = 'SET_ITEMS';
export var SET_MENU_STATE = 'SET_MENU_STATE';
export var ITEMS_LOADED = 'ITEMS_LOADED';